import * as ExcelJS from "exceljs";
import FileSaver from "file-saver";

export const excelFileDownload = async (columnData, apiData, fileName) => {
  // Check if fileName is a valid string
  if (typeof fileName !== "string" || fileName.trim() === "") {
    console.error("Invalid fileName:", fileName);
    fileName = "Default File Name"; // Fallback value
  }

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Report");

  // Set up columns based on columnData
  sheet.columns = columnData.map((item, id) => ({
    // key: `col${id + 1}`,
    key: item.field,
    width: 25,
  }));

  // Add header row
  const headerRow = sheet.addRow(columnData.map((item) => item.headerNm));
  headerRow.font = { bold: true };
  headerRow.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFCFCFCF" },
  };

  // Add data rows
  apiData.forEach((data) => {
    sheet.addRow(
      columnData.map((item, index) => {
        if (item.field === "") {
          return index + 1;
        } else if (item.field === "STATUS_CD") {
          if (data[item.field] === "P") return "Pending";
          if (data[item.field] === "A") return "Assign";
          if (data[item.field] === "I") return "In-Progress";
          if (data[item.field] === "O") return "Open";
          if (data[item.field] === "R") return "Re-Open";
          if (data[item.field] === "C") return "Close";
        }
        else {
          return data[item.field] || "";
        }
      })
    );
  });

  // Set alignment for each column
  columnData.forEach((items, id) => {
    sheet.getRow(id + 8).alignment = { horizontal: items.align }; // Adjusting for header and other rows
  });

  // Save the workbook
  workbook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    FileSaver.saveAs(blob, fileName + ".xlsx");
  });
};
